import { h } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { updateCSSVarScrollbarWidth, tagParser } from '../../js/modules/utilities'

export const MessageConnexion = ({ CTA, cacheKey }) => {
   const [isClosed, setisClosed] = useState(document.cookie.search('messageConnexionClosed') !== -1 ? true : false)

   const closeBanner = (e) => {
      e.preventDefault()
      setisClosed(true)
      document.cookie = 'messageConnexionClosed=1;'
   }

   useEffect(() => {
      updateCSSVarScrollbarWidth()
   }, [])

   return isClosed ? null : (
      <div class="position-relative">
         <a
            href={CTA.URL}
            id="message-connexion"
            class="message-connexion"
            data-pdb-zid={CTA.analytics.pdbZid}
            data-pdb-sc={CTA.analytics.pdbSc}
            data-pdb-idc={CTA.analytics.pdbIdc}
            data-oevent-category={CTA.analytics.oeventCategory}
            data-oevent-action={CTA.analytics.oeventAction}
            data-oevent-label={CTA.analytics.oeventLabel}
            data-oevent-other={CTA.analytics.oeventOther}
            data-testid="message-connexion"
            data-cache-key={cacheKey}
         >
            <div class="site-width alert-container alert-info">
               <div class="container-fluid">
                  <p class="alert">
                     <span class="icon-first" aria-hidden="true"></span>
                     <span class="alert-info-title" dangerouslySetInnerHTML={{ __html: tagParser(CTA.label) }} />
                  </p>
               </div>
            </div>
         </a>
         <button type="button" id="closeMessageConnexion" class="closeMessageConnexion btn" onClick={closeBanner} title="Fermer le message" aria-label="Fermer le message">
            &times;
         </button>
      </div>
   )
}
